/* Nota: el genérico es `any` a propósito. Los módulos de Medtronic
   (inventory, interventions, inventoryEquipments) mandan payloads libres
   a create/update que no encajan en el modelo tipado de Biomédica. */
import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';
import { StockModel } from '@shared/models/entities/stock.model';

@Injectable({ providedIn: 'root' })
export class StockService extends ApiBaseService<any> {
  constructor() {
    super('stock');
  }
}